var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-layout',{attrs:{"mw1":""}},[_c('v-col',{attrs:{"cols":"12"}},[_c('template-create-update',{attrs:{"is-create":true},on:{"success":_vm.back,"cancel":_vm.back}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }